export default {
  methods: {
    postMessage(event) {
      parent.postMessage(event, "*")
    }
  }
}